import React, { useState } from 'react'
import { FaCopy, FaCheck, FaDownload } from 'react-icons/fa'
import { Box, Stack, Text, Button, Icon, Alert, SimpleGrid } from '@/components/lib'
import utils from '../../utils/utils'

// Shows a freshly generated set of recovery codes - the only time they are
// readable - with copy and download so they can be put somewhere safe.
// Used on the enrolment screen (first MFA method) and from settings
// (regeneration).
export default function RecoveryCodes ({ codes }) {
  const [copied, setCopied] = useState(false)

  const asText = () => [
    'Trialflare recovery codes',
    '',
    'Each code signs you in once, with your password, if you lose access to your usual second factor.',
    'Keep them somewhere safe and private.',
    '',
    ...codes
  ].join('\n')

  function copy () {
    utils.copyToClipboard(asText())
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  function download () {
    const blob = new Blob([asText()], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'trialflare-recovery-codes.txt'
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <Stack gap={4}>
      <Alert status='warning' variant='left-accent'>
        These codes are shown once. Save them somewhere safe and private (such as a password manager). Each one signs you in a single time, along with your password, if you ever lose the device you use for two-factor authentication.
      </Alert>
      <SimpleGrid columns={2} gap={2} p={4} bg='bg.surface' rounded='md' borderWidth='1px'>
        {codes.map(code => (
          <Text key={code} fontFamily='mono' fontSize='lg' letterSpacing='wider' textAlign='center'>{code}</Text>
        ))}
      </SimpleGrid>
      <Stack direction='row'>
        <Button variant='outline' onClick={copy}><Icon as={copied ? FaCheck : FaCopy} mr={2} /> {copied ? 'Copied' : 'Copy'}</Button>
        <Button variant='outline' onClick={download}><Icon as={FaDownload} mr={2} /> Download</Button>
      </Stack>
      <Box>
        <Text fontSize='sm' color='fg.muted'>You can generate a new set at any time from Settings → Password & two-factor.</Text>
      </Box>
    </Stack>
  )
}
